import { createFactory, ReactFragment } from 'react';
import { withTranslation } from 'react-i18next';
import { compose, withStateHandlers } from 'recompose';
import Container from './Container';

const container = createFactory(Container);

export const withModal = (name, component) => (BaseComponent) => {
  const componentFactory = createFactory(component);
  const baseFactory = createFactory(BaseComponent);
  return compose(
    withTranslation(['common']),
    withStateHandlers(
      ({ isModalOpened, state }) => ({
        isModalOpened: isModalOpened || false,
        state: state || void 0,
      }),
      {
        showModal:
          (s, { isModalOpened, showModal }) =>
          (_name, state) => {
            if (_name === name) return { isModalOpened: true, state };
            if (showModal) showModal(_name, state);
            return s;
          },
        hideModal:
          (s, { isModalOpened, hideModal }) =>
          (_name) => {
            if (_name === name) return { isModalOpened: false, state: void 0 };
            if (hideModal) hideModal(_name);
            return s;
          },
      }
    )
  )(({ state, ...props }) => [
    baseFactory({ ...props, key: 1 }),
    props.isModalOpened &&
      container({ props, state, name, component: componentFactory, key: 2 }),
  ]);
};
